export default __webpack_public_path__ + "static/media/img (1).68a04451.jpg";